import React, { FunctionComponent, ReactElement, ChangeEvent } from 'react';
import styled from 'styled-components';

const StyledInput = styled.input<{ hasError: boolean }>`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 1px solid ${({ theme, hasError }) => (hasError ? theme.colors.red90 : theme.colors.charcoal20)};
    border-radius: 3px;
    display: inline-block;
    height: 19px;
    width: 19px;
    position: absolute;
    background: white;
    left: 0;
    top: 0;
    &:checked:before {
        appearance: none;
        background: white;
    }
    &:checked:after {
        appearance: none;
        background: white;
        content: '\\2714';
        font-size: 80%;
        position: absolute;
        top: 2px;
        left: 2px;
        color: ${({ theme }) => theme.colors.turquoise100};
    }
`;

export interface CheckBoxProps {
    name: string;
    checked: boolean;
    handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    hasError?: boolean;
}

const CheckBox: FunctionComponent<CheckBoxProps> = ({
    name,
    checked,
    handleInputChange,
    className,
    hasError = false,
}): ReactElement => (
    <StyledInput
        className={className}
        checked={checked}
        type="checkbox"
        name={name}
        onChange={handleInputChange}
        hasError={hasError}
    />
);

export default CheckBox;
